import React from "react";
import i18n from "../i18n/locales/config";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="text-right mb-4">{t("حریم خصوصی")} </p>
      <div className="textCard text-justify p-3 m-3">
        {/* <p className="m-0 fn12">
          مهم‌ترین سرمایه‌ی ما در ماندگار مدار آوین کاربران و مشتریانی هستند که
          به این شرکت اعتماد کرده‌اند و از محصولات آن استفاده می‌کنند. ما
          به‌خوبی آگاهیم که حفظ حریم خصوصی شما تا چه میزان برای‌تان اهمیت دارد،
          از این رو سند «سیاست حفظ حریم خصوصی ماندگار مدار آوین » را در
          اختیارتان قرار می‌دهیم تا از جزییات آن آگاه شوید. با پذیرش سیاست حفظ
          حریم خصوصی ماندگار مدار آوین،بهره‌گیری از هریک از خدمات قابل ارایه از
          سوی ماندگار مدار آوین، استفاده از پلتفرم ، وب سرویس ها و اپلیکیشن
          ماندگار مدار آوین و هرگونه تعامل با ماندگار مدار آوین در چارچوب‌های
          ذکرشده در این سند، به‌معنای پذیرش مفاد این سند از سوی شما خواهد بود.
          <br />
          چه تعهداتی به شما داریم؟
          <br />
          ماندگار مدار آوین یک شرکت ارایه‌دهنده‌ی زیرساخت ابری اینترنت اشیاء و
          ادوات سخت افزاری این حوزه است که روزانه به هزاران درخواست ترافیکی پاسخ
          می‌دهد و در تلاش است تا اشیاء متصل به اینترنت را در بستری امن میزبانی
          کند. با توجه به چنین وظیفه‌ی خطیری، این شرکت خود را متعهد به برقراری
          ارتباط شفاف و محافظت از داده‌هایی از کاربران خود می‌داند که در اختیار
          دارد. اطلاعاتی که در اختیار ما قرار می‌دهید مانند نام و نام خانوادگی،
          اطلاعات تماس، اطلاعات بانکی و اطلاعات مربوط به دستگاه ها به هیچ‌وجه به
          فروش نخواهد رسید و اجاره داده نخواهد شد. هم‌چنین این داده‌ها خارج از
          آن‌چه در آخرین نسخه‌ی این سند آمده ‌است با هیچ فرد یا نهادی افشا یا به
          اشتراک گذاشته نمی‌شود. ماندگار مدار آوین در هیچ زمانی ترافیک مشتریان و
          کاربرانش را به‌شکل غیرقانونی و غیرمجاز شنود نخواهد کرد و هیچ نرم‌افزار
          یا تجهیزاتی وابسته به مراجع امنیتی یا قضایی، با هدف ذخیره‌سازی یا شنود
          اطلاعات به‌شکل جزیی یا کلی، در هیچ نقطه از شبکه‌ی ماندگار مدار آوین
          وجود ندارد. این شرکت کلید رمزنگاری و تایید هویت خود یا مشتریان خود را
          غیرقانونی در اختیار هیچ شخص یا نهادی نمی‌گذارد و همواره مشتریان را به
          استفاده از رمزنگاری داده‌ها و ارتباطات رمزنگاری شده تشویق می‌کند.
          <br />
          چه اطلاعاتی از شما را جمع‌آوری می کنیم؟
          <br />
          اطلاعات حساب کاربری: هنگامی‌که برای ایجاد حساب کاربری ثبت‌نام می‌کنید،
          ماندگار مدار آوین اطلاعات تماس شما را گردآوری خواهد کرد. این اطلاعات
          شامل نام، نشانی ایمیل، کد ملی، شماره تلفن و نشانی‌های ضروری برای
          پردازش و انتقال سرویس‌هاست. هنگامی‌که هرگونه اطلاعات شخصی یا حقوقی را
          به ما ارایه می‌دهید، به این معنی است که صاحب آن اطلاعات هستید یا
          اجازه‌ی لازم برای ارایه‌ی آن به ما را دارید. اطلاعات بازدیدکنندگان از
          اپلیکیشن و پلتفرم: مانند بسیاری از اپلیکیشن ها و وب سایت ها زمانی‌که
          از سرویس های ماندگار مدار آوین بازدید می‌کنید، ما داده‌هایی چون نشانی
          IP، اطلاعات پیکربندی سیستم، URLهای صفحات مراجعه‌شده و اولویت‌های
          منطقه‌ای و زبانی شما را ذخیره خواهیم کرد. کوکی‌ها: ماندگار مدار آوین
          برای اهدافی چون ارایه‌ی اطلاعات درباره‌ی روش تعامل شما با وب‌سایت‌ها و
          اپلیکیشن ها و کمک به فعالیت‌های بازاریابی خود، از کوکی‌ها و سایر
          فناوری‌های مجاز گردآوری اطلاعات استفاده می‌کند. شما می‌توانید با
          پیکربندی تنظیمات حریم خصوصی مرورگر خود چگونگی استفاده از کوکی‌ها را
          کنترل کنید. اطلاعات بخش‌های تعاملی: این امکان وجود خواهد داشت که
          ماندگار مدار آوین در آینده انجمن‌های گفت‌وگو یا سایر بسترهای تعاملی را
          ایجاد کند. هم‌چنین امکان ثبت نظر در قسمت‌های مختلف وب‌سایت وجود دارد.
          در نظر داشته باشید هر گونه اطلاعاتی در این قسمت‌ها به اشتراک بگذارید
          خوانده و گردآوری خواهد شد. داده‌های لاگ ‌شده: ماندگار مدار آوین
          اطلاعات کاربران نهایی را به نمایندگی از مشتریان خود پردازش می‌کند. این
          اطلاعات هنگامی پردازش می‌شوند که کاربران نهایی وارد پلتفرم و اپلیکیشن
          مشتریان ما شده و از آن‌ها استفاده می‌کنند .اطلاعات پردازش شده ممکن است
          شامل نشانی‌های IP، اطلاعات پیکربندی سیستم و سایر اطلاعات ترافیک به/از
          وب‌سایت‌های مشتریان، ابزارها، برنامه‌ها یا شبکه‌ها (در مجموع، داده‌های
          ثبت‌شده) شود، اما به آن‌ها محدود نخواهد شد. اطلاعات شرکت‌کنندگان در
          رویدادها: زمانی‌که در رویدادهای ماندگار مدار آوین مشارکت می‌کنید یا در
          پژوهش‌ها و مطالعات تجربه‌ی کاربری سهیم می‌شوید ما اطلاعات شخصی مانند
          نام، شماره تلفن، نشانی ایمیل و داده‌ها و نظراتی که با در میان
          گذاشته‌اید را گردآوری خواهیم کرد. تصویر و صدا: هنگامی‌که با بخش صدای
          مشتریان یا پشتیبانی ماندگار مدار آوین تماس می‌گیرید یا در پژوهش‌های
          تصویری و مصاحبه‌های آروان شرکت می‌کنید، از شما درخواست خواهیم کرد که
          برای بررسی‌های بیش‌تر اجازه ضبط صدا و تصویرتان را به ما بدهید که تنها
          با تایید شما، این صدا و تصویر ذخیره خواهد شد. ماندگار مدار آوین در
          فرآیند SSL Offloading نیز عملیات با مجوز و کلید خصوصی کاربر و بدون
          هرگونه شنود غیرقانونی اطلاعات انجام می‌شود.
          <br />
          سیاست حفظ حریم خصوصی ماندگار مدار آوین در چه مواردی اعمال نمی‌شود؟
          <br />
          دامنه‌ها، وب‌سایت‌ها، رابط‌های برنامه‌نویسی کاربردی، برنامه‌ها و
          شبکه‌هایی که شرایط و سیاست حفظ حریم خصوصی خاص خود را دارند.
          <br />
          چه استفاده‌ای از اطلاعات جمع‌آوری شده می‌کنیم؟
          <br />
          تامین، اداره، حفظ، بهبود، تسهیل دسترسی و ارتقای سرویس‌ها و خدمات برای
          تمام کاربران. پردازش و تکمیل تراکنش‌ها و ارسال اطلاعات مرتبط با خریدها
          و فاکتورها. پاسخ‌گویی به نظرات، پرسش‌ها و درخواست‌های شما و تامین
          سرویس و پشتیبانی از مشتری. ارسال اخطارهای فنی، به‌روزرسانی‌ها،
          هشدارهای امنیتی و پشتیبانی. ارسال ارتباطات تجاری مانند اطلاعات
          درباره‌ی محصولات و سرویس‌ها، امکانات، نظرسنجی‌ها، خبرنامه‌ها،
          پیشنهادها، بهبودها، رقابت‌ها و رویدادهای مربوط به ما و شرکای ما و
          ارسال اخبار و اطلاعات درباره‌ی ما و شرکای ما. پیروی از تعهدات قانونی و
          بررسی و جلوگیری از تراکنش‌های کلاه‌بردارانه، دسترسی‌های نامعتبر به
          سرویس‌ها و سایر فعالیت‌های غیرقانونی مانند فیشینگ یا هرزه‌نگاری.
          داده‌های ثبت شده از کاربران نهایی: ما داده‌های ثبت‌شده از کاربران
          نهایی را برای برآورده کردن تعهدات خود در توافق‌نامه‌ی مشتری و در
          محدوده‌ای که قوانین و مقررات مجاز می‌دانند، استفاده و پردازش خواهیم
          کرد. دسترسی: اگر در ماندگار مدار آوین ثبت‌نام کرده‌اید، ممکن است کسانی
          که به حساب کاربری یا ایمیل ارایه شده شما دسترسی مجاز دارند، بتوانند
          اطلاعات ثبت شده شما را مشاهده کنند. امنیت: ماندگار مدار آوین برای
          محافظت از سرویس‌های شما انواع فناوری‌ها و امکانات امنیتی را به کار
          می‌گیرد تا از اطلاعات شما در برابر دسترسی نامعتبر، سواستفاده یا افشای
          آن‌ها محافظت کند. با این حال، مسوولیت ماندگار مدار آوین در خصوص حفاظت
          از داده‌ها و اطلاعاتی که بر اساس مفاد این سند در اختیار دارد،در هیچ
          موقعیتی فراتر از اسناد «سطح کیفیت خدمات(SLA)» و «شرایط استفاده از
          خدمات» نخواهد بود و ماندگار مدار آوین مسوولیتی فراتر از آن‌چه در SLA
          ذکر شده است، نخواهد داشت. هم‌چنین اگر از سرویس‌های امنیت ماندگار مدار
          آوین استفاده می‌کنید به این معناست که مسوولیت جمع‌آوری و پردازش این
          اطلاعات به وسیله‌ی ماندگار مدار آوین را پذیرفته‌اید.
          <br />
          با چه کسانی اطلاعات را به اشتراک می‌گذاریم؟
          <br />
          ماندگار مدار آوین با شرکت‌های ارایه‌دهنده خدمات مختلفی برای اداره‌ی
          کسب‌وکارش همکاری می‌کند. این شرکت‌ها سرویس‌هایی را برای کمک به
          پشتیبانی مشتریان، پرداخت‌های مالی، بازاریابی و بهبود سرویس‌های ما به
          هر طریقی، تامین می‌کنند. ما به ارایه‌دهندگان خدمات خود اجازه نمی‌دهیم
          هیچ کدام از اطلاعاتی که از مشتریان‌مان با آن‌ها به اشتراک گذاشته‌ایم
          را به فروش برسانند یا برای اهداف بازاریابی خود یا هر هدف دیگری، به‌جز
          در ارتباط با خدماتی که به ماندگار مدار آوین ارایه می‌دهند، استفاده
          کنند. با این حال، مسئولیت هرگونه افشای اطلاعات از منظر قانونی و به‌شکل
          انحصاری با ‌شخصی‌ (اعم از حقیقی یا حقوقی) است که افشا از ناحیه‌ی او
          انجام شده باشد. علاوه‌بر اشتراک‌گذاری اطلاعات با ارایه‌دهندگان خدمات،
          ممکن است در شرایط خاصی اطلاعات شما را با دیگران نیز به اشتراک بگذاریم:
          در گروه‌های پشتیبانی ماندگار مدار آوین (طبق سیاست حفظ حریم خصوصی).
          فروشندگان و سایر شرکای فروشی که در توزیع خدمات به ما کمک می‌کنند
          (مانند شرکای ما در کوچ پلتفرم های هوشمند اینترنت اشیاء) توسعه‌دهندگان
          نرم‌افزارهای اینترنت اشیاء، زمانی‌که این نرم‌افزارها را از ماندگار
          مدار آوین دانلود می‌کنید. اگر ادغام، فروش یا تغییری در کنترل یا
          سازمان‌دهی مجدد تمام یا بخشی از ماندگار مدار آوین انجام شود؛ در این
          حالت پیش از به اشتراک‌گذاری اطلاعات شما با شرکت جدید، این موضوع به
          اطلاع‌تان خواهد رسید و نظر شما را درباره‌ی ادامه‌ی استفاده از خدمات
          ماندگار مدار آوین یا خروج کامل از آن پرسیده می‌شود. هنگامی‌که لازم است
          اطلاعات شخصی و موردی را برای پاسخ‌دهی به احضاریه‌ها، قوانین و مقررات
          یا دستورات قضایی افشا کنیم یا در برابر ادعاهای مطرح‌شده از خود دفاع
          کنیم؛ در این حالت ناگزیر از ارایه‌ی داده‌ها و اطلاعات به‌مراجع قانونی
          هستیم که اطلاعات آن به‌شکل فصلی در صفحه‌ی گزارش شفافیت ماندگار مدار
          آوین منتشر می‏‌شود. ماندگار مدار آوین در ایران قرار دارد و اطلاعات شما
          را در ایران ذخیره خواهد کرد. با این حال، ممکن است به‌منظور تسهیل
          عملکردهای بین‌المللی خود، این اطلاعات به هر نقطه در جهان، از جمله
          کشورهایی که ماندگار مدار آوین در آن‌ها فعالیت دارد، انتقال یابد و به
          آن دسترسی پیدا کنیم.
          <br />
          چه حقوق و انتخاب‌هایی در سیاست حفظ حریم خصوصی دارید؟
          <br />
          به‌دلیل حساسیت بالای اطلاعات سرویس‌های شما، در زمان ثبت نام در ماندگار
          مدار آوین از شما احراز هویت انجام می‌شود تا اطمینان پیدا کنیم که این
          اطلاعات در دست صاحبان اصلی اکانت است. اگر درخواست دسترسی داده‌ها به
          شخص دیگری را داشته باشید ماندگار مدار آوین این درخواست را با توجه به
          خطر نقض حقوق حریم خصوصی و مطابق قوانین بررسی خواهد کرد. شما حق دسترسی،
          تصحیح، به‌روزرسانی اطلاعات شخصی خود را دارید. می‌توانید درباره‌ی هر
          درخواست دسترسی با ایمیل support@mmaviot.com در ارتباط باشید. هم‌چنین
          مشتریان و صاحبان اکانت می‌توانند از طریق ویرایش پروفایل خود یا
          سازمان‌دهی رکورد در پنل کاربری، به اطلاعات شخصی‌شان دسترسی داشته باشند
          و آن را تصحیح یا به‌روزسانی کنند.
          <br />
          چگونه دسترسی اطلاعات خود را از ماندگار مدار آوین بگیرید؟
          <br />
          در حال حاضر امکان حذف یا غیرفعال کردن حساب کاربری وجود ندارد. اما اگر
          علاقه‌مند به دریافت پیامک یا ایمیل‌های بازاریابی و اطلاع‌رسانی نبودید،
          می‌توانید در پایین ایمیل خود دستورالعمل «لغو اشتراک» را به‌کار بگیرید.
          اگر مشتری ماندگار مدار آوین هستید این کار را می‌توانید از طریق پنل
          کاربری‌تان انجام دهید یا درخواست خود را به نشانی support@mmaviot.com
          ارسال کنید. پیش از آن‌که اشتراک ایمیل‌های ماندگار مدار آوین را لغو
          کنید، در نظر داشته باشید که ماندگار مدار آوین تمام اطلاعات تراکنشی و
          اطلاعیه‌های مرتبط با سرویس‌های شما را از طریق ایمیل انجام می‌دهد.
          <br />
          چگونه با ما در تماس باشید؟
          <br />
          اگر هر نوع پرسش یا ابهامی درباره‌ی سیاست حفظ حریم شخصی ماندگار مدار
          آوین دارید، با ما با ایمیل support@mmaviot.com در ارتباط باشید. اگر
          اعتقاد دارید رونوشت‌هایی از داده‌های شخصی شما را در خارج از محدوده‌ی
          سیاست حفظ حریم خصوصی نگه‌داری می‌کنیم، می‌توانید این مورد را با ارسال
          ایمیل به آدرس support@mmaviot.com مطرح کنید. ما پس از دریافت ایمیل و
          تایید هویت شما، به این ابهامات پاسخ خواهیم داد.
          <br />
          آخرین تاریخ به‌روزرسانی: شهریور ۱۴۰۰
        </p> */}
      </div>
    </div>
  );
};

export { PrivacyPolicy };
